import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <nav
      aria-label="面包屑"
      className="mx-auto w-full max-w-7xl px-4 pt-6 md:px-6"
    >
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600">
        {crumbs.map((c, idx) => (
          <li key={idx} className="flex items-center gap-1.5">
            {idx > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
            {c.to ? (
              <Link
                to={c.to}
                className="cursor-pointer whitespace-nowrap transition-colors hover:text-primary-600"
              >
                {c.label}
              </Link>
            ) : (
              <span className="whitespace-nowrap text-foreground-950">{c.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}